import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { IssueComment } from "src/util/types/dataModels/issueComment"

//region Types

export type IssueOnItemCommentDocument = RxDocument<IssueComment>
export type IssueOnItemCommentCollection = RxCollection<IssueComment>

//endregion

/**
 * Schema for issue on item comment collections
 */
export const issueOnItemCommentSchema: RxJsonSchema<IssueComment> = {
  title: "Issue on Item Comment schema",
  description: "Collection of all the issue on item comments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    text: { type: "string", maxLength: 2048 },
    reaffirmed: { type: "boolean" },
    user: { type: "string", maxLength: 36 },
    issue: { type: "string", maxLength: 36 },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "text", "reaffirmed", "user", "issue"],
  indexes: ["issue"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const issueOnItemCommentCollectionCreator: RxCollectionCreator = {
  schema: issueOnItemCommentSchema,
}
